
import { __assign } from 'tslib';

/**
 * @public
 */
export function assign<T, E>(base: T, extension: E): T & E {
  return __assign(base, extension);
}
